var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,errorKey){return _c('div',{key:(_vm.name + "-" + errorKey),staticClass:"error"},[_vm._v(" "+_vm._s(error)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }